export default "__VITE_ASSET__KeI6Ebt3__"